<template>
  <f7-page
    class="main-status-summary"
  >
    <template #fixed>
      <TheNavbar
        v-if="expeditionDocument != null"
        :nav-title="`${expeditionDocument.Serie} / ${expeditionDocument.Numero}`"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        :style="appTheme"
      >
        <template #right>
          <div
            class="display-flex"
          >
            <f7-link
              v-if="expeditionDocument.EstadoOrdenCarga !== 2"
              @click="EventOpenReadAns"
            >
              <img :src="icQr">
            </f7-link>
            <f7-link
              icon="icon-options_dark"
              @click="openActions = true"
            />
          </div>

          <!--
        <divicon-task_list
          v-if="expeditionDocument.EstadoOrdenCarga != 2"
          class="display-flex"
        >
          <f7-link
            icon="icon-addNew"
            @click="NavigateToAddLine"
          />
          <f7-link
            icon="icon-edit"
            @click="NavigateToEditExpedition"
          />
          <f7-link
            icon="icon-delete"
            @click="EventDeleteLine"
          />
        </div>
         -->
          <!-- <div
            v-if="expeditionDocument.EstadoOrdenCarga === 2"
            class="display-flex"
          >
            <f7-link
              icon="icon-edit"
              @click="NavigateToShowDeliveryNotes"
            />
            <f7-link
              :class="disablePrint ? 'disabled-component' : null"
              icon="icon-print"
              @click="PrintExpedition"
            />
            <f7-link
              icon="icon-reload-blue"
              @click="ChangeStateExpedition"
            />
          </div> -->
        </template>
      </TheNavbar>
    </template>

    <div
      v-if="documentoExpedicion != null"
      class="content-header"
    >
      <f7-list class="padding-vertical">
        <f7-list-item
          :title="$t('common.carrier')"
          :after="documentoExpedicion.Transportista != null ? `${documentoExpedicion.Transportista.Codigo} - ${documentoExpedicion.Transportista.Sujeto.NombreCompleto}` : ''"
        />
        <f7-list-item
          :title="$t('common.departure')"
          :after="documentoExpedicion.FechaSalida != null ? GetDepartureDate() : ''"
        />
        <f7-list-item
          v-if="pendienteEnOtroCentro"
          :title="$t('commercialization.common.loading')"
          :after="$t('commercialization.common.loadingPendingInAnotherCenter')"
        />
      </f7-list>
    </div>

    <!-- accordeon -->

    <!-- <pre>{{elementFilter}}</pre> -->

    <div
      v-if="elementFilter != null"
      class="accordion"
    >
      <f7-list
        v-for="(items, i) in elementFilter"
        :key="i"
        accordion-list
        class="custom-accordion"
      >
        <f7-list-item
          accordion-item
          :opened="true"
          class="accordion-item-opened"
        >
          <template #title>
            <div>
              <span v-if="items[0].items[0].Cliente != null">
                {{ items[0].items[0].Cliente.Nombre }}
              </span>
              <span v-else>
                {{ $t('commercialization.common.thereIsNoTitle') }}
              </span>
            </div>
          </template>

          <f7-accordion-content>
            <div
              v-for="(option, j) in items"
              :key="j"
            >
              <UCAcordeon
                :items="[option]"
                badge-text-color="var(--his-oliva)"
                font-color="var(--his-dark-blue)"
                primary="var(--his-light-blue)"
                :after-title="false"
              >
                <template #titleOption>
                  {{
                    showAddressName
                      ? option.items[0].Direccion != null
                        ? `${option.items[0].Direccion.Nombre} - ${option.items[0].Direccion.Direccion}`
                        : $t('commercialization.common.noAddress')
                      : option.items[0].Direccion != null
                        ? option.items[0].Direccion.Direccion
                        : $t('commercialization.common.noAddress')
                  }}
                  <!-- {{option.items[0].Direccion != null ? option.items[0].Direccion.Direccion : $t('commercialization.common.noAddress')}} -->
                </template>
                <template #subOption="{ item }">
                  <f7-list-item
                    link="#"
                    @click="NavigateToEditExpeditionLine(item)"
                  >
                    <template #default>
                      <div class="item-info">
                        <div
                          v-if="item.CantidadTotalCargada === 0"
                          class="item-info__start pending"
                        >
                          {{ $t('common.pending').toUpperCase() }}
                        </div>
                        <div
                          v-if="item.CantidadTotalCargada < item.CantidadTotalPales && item.CantidadTotalCargada > 0"
                          class="item-info__start in-process"
                        >
                          {{ $t('commercialization.common.loadingInProcess').toUpperCase() }}
                        </div>
                        <div
                          v-if="item.CantidadTotalCargada === item.CantidadTotalPales"
                          class="item-info__start finished"
                        >
                          {{ $t('common.numberCompleted').toUpperCase() }}
                        </div>

                        <div
                          class="item-info__end"
                          :class="GetItemAfterClassByQuantity(item)"
                        >
                          {{ `${item.CantidadTotalCargada} ${$t('common.of')} ${item.CantidadTotalPales}` }}
                        </div>
                      </div>

                      <div class="item-title-row">
                        <div class="item-title">
                          {{ item.Producto.Nombre }}
                        </div>
                      </div>

                      <div class="item-subtitle">
                        {{ `${item.Envase.Nombre} | ${item.Marca}` === null ? item.Marca.Nombre : '' }}
                      </div>

                      <div class="item-text">
                        {{ item.Pale.Nombre }}
                      </div>

                      <div class="item-footer">
                        {{
                          `${(item.LineaPedidoVenta.PedidoVenta === null
                            ? ''
                            : `${item.LineaPedidoVenta.PedidoVenta.Serie === null
                              ? ''
                              : item.LineaPedidoVenta.PedidoVenta.Serie}/${item.LineaPedidoVenta.PedidoVenta.Numero}-${item.LineaPedidoVenta.Orden}`)}`
                        }}
                      </div>
                    </template>
                  </f7-list-item>
                </template>
              </UCAcordeon>
            </div>
          </f7-accordion-content>
        </f7-list-item>
      </f7-list>
      <UCPreload :show="showPreload" />
    </div>
    <!-- MENU DE OPCIONES -->
    <div id="menu-options">
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="openActions"
        @actions:closed="openActions = false"
      >
        <f7-actions-group
          class="actions-content"
          style="height: fit-content;"
        >
          <f7-actions-label class="action-label disablePrint ? 'disabled-component' : null">
            <f7-actions-button
              class="actions-btn"
              @click="PrintExpedition"
            >
              <span class="text-left">
                {{ $t('commercialization.common.printOrder') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>
          <f7-actions-label
            v-if="expeditionDocument.EstadoOrdenCarga === 2"
            class="action-label"
          >
            <f7-actions-button
              class="actions-btn"
              @click="NavigateToShowDeliveryNotes"
            >
              <span class="text-left">
                {{ $t('commercialization.common.showDocuments') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>
          <!-- <div
            v-if="expeditionDocument.EstadoOrdenCarga != 2"
          > -->
          <f7-actions-label
            v-if="expeditionDocument.EstadoOrdenCarga !== 2"
            class="action-label"
          >
            <f7-actions-button
              class="actions-btn"
              @click="EventDeleteLine"
            >
              <span class="text-left">
                {{ $t('commercialization.common.deleteOrder') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>

          <f7-actions-label
            v-if="expeditionDocument.EstadoOrdenCarga !== 2"
            class="action-label"
          >
            <f7-actions-button
              class="actions-btn"
              @click="NavigateToEditExpedition"
            >
              <span class="text-left">
                {{ $t('commercialization.common.editOrder') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>

          <f7-actions-label
            v-if="expeditionDocument.EstadoOrdenCarga !== 2"
            class="action-label"
          >
            <f7-actions-button
              class="actions-btn"
              @click="NavigateToAddLine"
            >
              <span class="text-left">
                {{ $t('commercialization.common.addLine') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>
          <!-- </div> -->

          <f7-actions-label
            v-if="expeditionDocument.EstadoOrdenCarga === 2"
            class="action-label"
          >
            <f7-actions-button
              class="actions-btn"
              @click="ChangeStateExpedition"
            >
              <span class="text-left">
                {{ $t('commercialization.common.changeStatus') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>

          <f7-actions-label
            v-if="expeditionDocument.EstadoOrdenCarga !== 2"
            class="action-label"
          >
            <f7-actions-button
              class="actions-btn"
              @click="openSignOption = true"
            >
              <span class="text-left">
                {{ $t('common.sign') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>
          <f7-actions-label class="action-label">
            <f7-actions-button
              class="actions-btn"
              @click="openComplementaryDataPopup = true"
            >
              <span class="text-left">
                {{ $t('common.complementaryData') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>

          <f7-actions-label class="action-label">
            <f7-actions-button class="actions-button-back actions-btn">
              <span class="text-left">
                {{ $t('commercialization.common.goBack') }}
              </span>
            </f7-actions-button>
          </f7-actions-label>
        </f7-actions-group>
      </f7-actions>
    </div>
    <!-- OPCION DE FIRMA -->
    <div id="sign-option">
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="openSignOption"
        @actions:closed="openSignOption = false"
      >
        <f7-actions-group
          class="actions-content"
          style="height: fit-content;"
        >
          <f7-actions-label class="signOption">
            <HIFormInputSignature
              class="margin-top-half content-signature"
              :label="$t('common.receivedBy')"
              :signature="signatureReceived"
              :are-buttons-rounded="true"
              @new-signature="updateSignatureReceived"
              @signature-cleared="signatureReceived = ''"
            />
          </f7-actions-label>

          <f7-actions-label class="signOption">
            <HIFormInputSignature
              class="margin-top-half content-signature"
              :label="$t('common.loadedBy')"
              :signature="signatureCharged"
              :are-buttons-rounded="true"
              @new-signature="updatesignatureCharged"
              @signature-cleared="signatureCharged = ''"
            />
          </f7-actions-label>
          <div class="content-action-sheet--items__buttons padding acceptCancelBox">
            <a
              class="color-grey"
              @click="openSignOption = false"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
            <!-- @click="actionNuevoArticulo = false" -->
            <a
              class="color-green aceptar-button"
              @click="GuardarFirmas"
            >
              {{ $t('common.accept').toUpperCase() }}
            </a>
            <!-- @click="EventNewArticle" -->
          </div>
        </f7-actions-group>
      </f7-actions>
    </div>

    <f7-popup
      v-model:opened="openComplementaryDataPopup"
      class="content-main-status-summary-popup"
    >
      <f7-page>
        <template #fixed>
          <TheNavbar
            :nav-title="$t('common.complementaryData')"
            popup-close-btn-enable
          />
        </template>

        <UCDatosComplementarios
          class="content-main-status-summary-popup__complementary-data"
          :activo="true"
          :entidad-seleccionada="{ Id: expeditionDocument?.Id ?? 0 }"
          :edition="true"
          tipo-entidad-seleccionada="OrdenCarga"
          @change-complementary-data="EventChangeComplementayData"
        />
        <div class="content-main-status-summary-popup__buttons display-flex justify-content-space-between padding">
          <f7-button
            outline
            @click="openComplementaryDataPopup = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </f7-button>
          <f7-button
            fill
            @click="acceptChangeComplementaryData"
          >
            {{ $t('common.confirm').toUpperCase() }}
          </f7-button>
        </div>
      </f7-page>
    </f7-popup>

    <!-- preloader -->

    <!-- Botones volver o confirmar
 -->
    <div
      v-if="expeditionDocument.EstadoOrdenCarga !== 2"
      class="container-finish-button"
    >
      <f7-button
        class="btn-confirmar margin-horizontal margin-top"
        fill
        @click="FinalizeExpedition()"
      >
        {{ $t('commercialization.common.finishExpedition') }}
      </f7-button>
    </div>
    <UCConfirmation ref="UCConfirmation" />
    <UCCodeScanner
      ref="UCCodeScannerExpeditionDocument"
      :continuous-bar-code-reading="true"
      :allow-manual-code-entry="true"
      :fab-button-show="false"
      :open-information-bar="infoSheetParams.opened"
      :title="infoSheetParams.title"
      :subtitle1="infoSheetParams.subtitle1"
      :state="infoSheetParams.state"
      @popup-close="closeScanner"
      @code-reading="EventReading($event, true)"
      @codigo-barras="EventReading($event, true)"
      @numero-serie="EventReading($event, false)"
    />
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useSettingRef } from '@erpagroapp/settings';
import { useParamRef } from '@erpagroapp/params';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import {
  ConfirmDialogGH,
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import icQr from '@/static/icons/ic_qr.svg';
import UCPreload from '@/components/common/UCPreload.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import UCDatosComplementarios from '@/components/common/UCDatosComplementarios.vue';
import HIFormInputSignature from '@/components/common/HIFormInputSignature.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import CargaCorrecta from '@/static/sounds/CargaCorrecta.mp3';
import ErrorCarga from '@/static/sounds/ErrorCarga.mp3';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import { useSound } from '@/composables/useSound';

/** @import { InfoSheetState } from '@erpagroapp/types' */

export default {
  name: 'FrmExpeditionDocument',

  components: {
    TheNavbar,
    UCAcordeon,
    UCPreload,
    UCConfirmation,
    HIFormInputSignature,
    UCCodeScanner,
    UCDatosComplementarios,
  },

  props: {
    expeditionDocument: {
      type: Object,
      required: true,
    },
    reload: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showPreload: true,
      documentoExpedicion: null,
      pendienteEnOtroCentro: false,
      elementFilter: [],
      disablePrint: false,
      openActions: false,
      openSignOption: false,
      openComplementaryDataPopup: false,
      signatureReceived: '',
      signatureCharged: '',
      signatureSavedReceived: null,
      signatureSavedCharged: null,
      icQr,
      isProcessingReadingsQueue: false,
      /** @type {string[]} */
      readingsQueue: [],
      introduccionManualCBLecturaPalesExpeciones: useParamRef('IntroduccionManualCBLecturaPalesExpeciones'),
      lecturaContinuaCargasExpediciones: useParamRef('LecturaContinuaCargasExpediciones'),
      showAddressName: useSettingRef('Expediciones.MostrarNombreDireccion'),
      soundCargaCorrecta: useSound(CargaCorrecta),
      soundErrorCarga: useSound(ErrorCarga),
      infoSheetParams: {
        opened: false,
        title: '',
        subtitle1: null,
        /** @type {InfoSheetState} */
        state: 'CAUTION',
      },
      complementaryData: null,
    };
  },

  computed: {
    ...mapState(useAppConfigStore, [
      'userEnviroment',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },

  created() {
    if (this.expeditionDocument.Matricula !== null && this.expeditionDocument.Matricula !== '' && this.expeditionDocument.EstadoOrdenCarga !== 2) {
      this.Conexion_CargaRelacionadaEnOtroCentro(this.expeditionDocument.Id);
    } else {
      this.pendienteEnOtroCentro = false;
    }
    this.Conexion_GetExpedition(this.expeditionDocument);
  },

  methods: {
    GetDepartureDate() {
      Log(this, this.GetDepartureDate.name);
      let date = null;
      const dateExpedition = this.expeditionDocument.FechaSalida;
      if (!Number.isNaN(Date.parse(dateExpedition))) {
        date = new Date(dateExpedition);
      }
      const dateModified = `${date.toLocaleDateString()} - ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

      return dateModified;
    },
    GetAccordeonList(docExp) {
      Log(this, this.GetAccordeonList.name);
      if (docExp === undefined || docExp.Lineas == null) {
        return;
      } // Todo revisar funcionalidad
      this.elementFilter = [];
      const filtro = docExp.Lineas;
      let direccion = '';
      let aniadido = false;
      filtro.forEach((element) => {
        const array = [];

        if (element.Direccion === null) {
          direccion = ' ';
        } else {
          direccion = element.Direccion.Nombre;
        }
        this.elementFilter.forEach((elementFilter) => {
          elementFilter.forEach((subElementFilter) => {
            if (subElementFilter.items[0].Cliente?.Nombre === element.Cliente?.Nombre) {
              if (subElementFilter.items[0].Direccion.Direccion === element.Direccion.Direccion) {
                subElementFilter.items.push(element);
                aniadido = true;
              }
            }
          });
        });
        this.elementFilter.forEach((elementFilter) => {
          elementFilter.forEach((subElementFilter) => {
            if (subElementFilter.items[0].Cliente?.Nombre === element.Cliente?.Nombre && !aniadido) {
              if (subElementFilter.items[0].Direccion.Direccion !== element.Direccion.Direccion) {
                const obj = {
                  Estado: direccion,
                  items: [element],
                };
                elementFilter.push(obj);
                aniadido = true;
              }
            }
          });
        });
        if (!aniadido) {
          array.push({
            Estado: direccion,
            items: [element],
          });
          this.elementFilter.push(array);
        }
        direccion = '';
        aniadido = false;
      });
    },
    async EventOpenReadAns() {
      Log(this, this.EventOpenReadAns.name);
      if (this.introduccionManualCBLecturaPalesExpeciones) {
        this.$refs.UCCodeScannerExpeditionDocument.Open();
        await sleep(200);
        this.$refs.UCCodeScannerExpeditionDocument.SetFocusOnInputElement();
      } else {
        this.$refs.UCCodeScannerExpeditionDocument.OpenAuto();
      }
    },
    closeScanner() {
      Log(this, this.closeScanner.name);
      if (this.lecturaContinuaCargasExpediciones) {
        this.Conexion_GetExpedition(this.expeditionDocument);
      }
    },

    /**
     * Processes a barcode or serial number reading, handles the queue.
     * @param {string} code - The barcode or serial number code.
     * @param {boolean} isBarcode - Whether the code is a barcode or a serial number.
     * @returns {Promise<void>}
     */
    async EventReading(code, isBarcode) {
      Log(this, this.EventReading.name);

      this.readingsQueue.push(code);
      if (this.readingsQueue.length === 1) {
        this.ProcessReading(code, isBarcode);
      }
    },

    EventChangeComplementayData(complementaryData) {
      Log(this, this.EventChangeComplementayData.name);
      this.complementaryData = complementaryData;
    },

    acceptChangeComplementaryData() {
      Log(this, this.acceptChangeComplementaryData.name);
      if (this.checkRequiredComplementaryData()) return;

      this.openComplementaryDataPopup = false;
      this.filterComplementaryData();

      if (this.documentoExpedicion && this.documentoExpedicion.Id) {
        this.GuardarDatosComplementariosExpedicion();
      }
    },

    filterComplementaryData() {
      Log(this, this.filterComplementaryData.name);

      this.complementaryData = this.complementaryData.reduce((acc, item) => {
        if (item.Valor.Valor !== null) {
          acc.push({
            Id: item.Id,
            Nombre: item.Nombre,
            Codigo: item.Codigo,
            Valor: item.Valor.Valor,
          });
        }
        return acc;
      }, []);
    },

    checkRequiredComplementaryData() {
      Log(this, this.checkRequiredComplementaryData.name);
      const rellenarRequeridos = this.complementaryData.filter((f) => f.Requerido && f.Valor.Valor === null).length > 0;

      if (rellenarRequeridos) {
        HiNotification.Toast(this.$t('warehouse.info.completeAllRequiredFields'));
        this.openComplementaryDataPopup = true;
      }

      return rellenarRequeridos;
    },

    /**
     * Processes a serial number or barcode reading, handles the queue.
     * @param {string} code - The barcode or serial number code.
     * @param {boolean} isBarcode - Whether the code is a barcode or a serial number.
     * @returns {Promise<void>}
     */
    async ProcessReading(code, isBarcode) {
      if (this.isProcessingReadingsQueue) {
        return;
      }

      this.isProcessingReadingsQueue = true;

      if (!this.lecturaContinuaCargasExpediciones) {
        this.$refs.UCCodeScannerExpeditionDocument.ClosePopup();

        const preloaderText = isBarcode ? this.$t('codeScanner.info.validatingBarcode') : this.$t('codeScanner.info.validatingSerialNumber');
        HiDialog.Preloader(true, preloaderText);
      }

      try {
        const result = isBarcode
          ? await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, false, true)
          : await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, true, false);

        HiDialog.Preloader(false);

        if (result.Valor) {
          const paleLeido = JSON.parse(result.Mensaje);
          await this.ReserveAndReloadPaleXOrderOrderNoLineOrder(paleLeido);
        } else {
          this.ShowInfoPale(false, result.Mensaje);
        }

        await this.RepeatProcessReading(isBarcode);
      } catch (error) {
        LogError(this, this.ProcessBarcodeReading.name, error);
        HiDialog.Preloader(false);
        this.RepeatProcessReading(isBarcode);
      }
    },

    /**
     * Repeats a serial number or barcode reading, handles the queue.
     * @param {boolean} isBarcode - Whether the code is a barcode or a serial number.
     * @returns {Promise<void>}
     */
    async RepeatProcessReading(isBarcode) {
      this.readingsQueue.shift();
      this.isProcessingReadingsQueue = false;

      if (this.readingsQueue[0]) {
        await this.ProcessReading(this.readingsQueue[0], isBarcode);
      }
    },

    /* async FilterByLoadedPallet(pale) {
      Log(this, this.FilterByLoadedPallet.name);
      let concidencia = false;
      // filtrar Pales reservados a la orden
      this.documentoExpedicion.Lineas.forEach((linea) => {
        linea.Desglose.forEach((des) => {
          if (des.UnidadContenedora != null) {
            if (des.UnidadContenedora.NumeroSerie === pale.NumeroSerie) {
              this.ReservarYCargarPaleXOrdenCarga(pale, linea.Id, this.documentoExpedicion.Id, linea.LineaPedidoVenta.Id);
              concidencia = true;
            }
          }
        });
      });
      if (!concidencia) {
        const unidadContenedora = await this.GetPaleReservado(pale.NumeroSerie);
        if (unidadContenedora.length > 0) {
          this.documentoExpedicion.Lineas.forEach((linea) => {
            if (linea.LineaPedidoVenta.Id === unidadContenedora[0].PedidoVenta.lineasPedidoVenta[0].Id) {
              this.ReservarYCargarPaleXOrdenCarga(pale, linea.Id, this.documentoExpedicion.Id, linea.LineaPedidoVenta.Id);
              concidencia = true;
            }
          });
        } else {
          // HiNotification.Toast('El palé no esta reservado a ninguna linea de pedido');
          this.ShowInfoPale(false, 'El palé no esta reservado a ninguna linea de pedido');
          concidencia = true;
        }
      }

      if (!concidencia) {
        this.ShowInfoPale(false, 'Sin coincidencias con palés reservados a orden de carga o al pedido');
        // HiNotification.Toast('Sin coincidencias con palés reservados a orden de carga o al pedido');
      }
    }, */
    /* async ReservarYCargarPaleXOrdenCarga(pale, idLinea, idExpedicion, idLineaPedidoVenta) {
      Log(this, this.ReservarYCargarPaleXOrdenCarga.name);
      if (!this.lecturaContinuaCargasExpediciones) {
        HiDialog.Preloader(true, this.$t('commercialization.info.loadingPallet'));
      }
      const result = await APIErp.callReservarYCargarPaleXOrdenCarga([pale], idLinea, idExpedicion, idLineaPedidoVenta);
      if (!this.lecturaContinuaCargasExpediciones) {
        HiDialog.Preloader(false);
      }

      await this.ProcessResponseChargePaleDirect(result.data);
      this.Conexion_GetExpedition(this.expeditionDocument);
    }, */

    GuardarDatosComplementariosExpedicion() {
      Log(this, this.GuardarDatosComplementariosExpedicion.name);
      try {
        this.complementaryData.forEach(async (data) => {
          await APIErp.callSaveComplementaryDataForExpedition([data], this.documentoExpedicion.Id);
        });
      } catch (error) {
        LogError(this, this.GuardarDatosComplementariosExpedicion.name, error);
        HiNotification.Toast(error);
      }
    },

    async ReserveAndReloadPaleXOrderOrderNoLineOrder(pale) {
      Log(this, this.ReserveAndReloadPaleXOrderOrderNoLineOrder.name);
      if (!this.lecturaContinuaCargasExpediciones) {
        HiDialog.Preloader(true, this.$t('commercialization.info.loadingPallet'));
      }
      const result = await APIErp.CallCargarPaleXOrdenCargaSinLineaOrden([pale], this.expeditionDocument.Id, true);
      if (!this.lecturaContinuaCargasExpediciones) {
        HiDialog.Preloader(false);
      }
      await this.ProcessResponseChargePaleDirect(result.data);
      if (!this.lecturaContinuaCargasExpediciones) {
        this.Conexion_GetExpedition(this.expeditionDocument);
      }
    },
    ProcessResponseChargePaleDirect(data) {
      Log(this, this.ProcessResponseChargePaleDirect.name);
      const elementOK = data.Tag.OK;
      const elementERROR = data.Tag.ERROR;

      if (elementOK.length > 0 && elementERROR.length === 0) {
        const pales = elementOK.map((element) => element.tag.UnidadContenedora.NumeroSerie);
        const message = pales.length === 1
          ? this.$t('commercialization.info.onePalletLoadedSuccessfully', { pallet: pales[0] })
          : this.$t('commercialization.info.palletsLoadedSuccessfully', { pallets: pales.join(', ') });
        this.ShowInfoPale(true, message);
        this.soundCargaCorrecta.play();
      } else if (elementOK.length === 0 && elementERROR.length === 1) {
        this.ShowInfoPale(false, elementERROR[0].mensaje);
      } else if (elementOK.length === 0 && elementERROR.length > 0) {
        const pales = elementERROR.map((element) => element.tag.NumeroSerie);
        const errorMessage = pales.length === 1
          ? `${this.$t('commercialization.info.palletNotLoaded', { pallet: pales[0] })} ${elementERROR[0].mensaje}`
          : `${this.$t('commercialization.info.palletsNotLoaded', { pallets: pales.join(', ') })} ${elementERROR[0].mensaje}`;
        this.ShowInfoPale(false, errorMessage);
      } else if (elementOK.length > 0 && elementERROR.length > 0) {
        this.ShowInfoPale(false, `${this.$t('commercialization.info.somePalletsNotLoaded')} ${elementERROR[0].mensaje}`);
      }
    },
    async ShowInfoPale(correcto, mensaje, timeToDisplay = 1500) {
      if (!correcto) {
        this.soundErrorCarga.play();
      }
      this.infoSheetParams.subtitle1 = mensaje;
      if (correcto) {
        this.infoSheetParams.title = this.$t('common.information');
        this.infoSheetParams.state = 'ENTER';
      } else {
        this.infoSheetParams.title = this.$t('common.incidence');
        this.infoSheetParams.state = 'ERROR';
      }

      this.infoSheetParams.opened = true;
      await sleep(timeToDisplay);
      this.infoSheetParams.opened = false;
    },
    NavigateToAddLine() {
      Log(this, this.NavigateToAddLine.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionEditLines', {
        props: {
          expeditionDocument: this.documentoExpedicion,
          editable: true,
        },
      });
    },
    NavigateToEditExpedition() {
      Log(this, this.NavigateToEditExpedition.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocumentCompleteData/', {
        props: {
          expeditionDocument: this.documentoExpedicion,
          editable: true,
        },
      });
    },
    NavigateToShowDeliveryNotes() {
      Log(this, this.NavigateToShowDeliveryNotes.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionSalesReceipt', {
        props: {
          expedition: this.documentoExpedicion,
        },
      });
    },
    async GuardarFirmas() {
      Log(this, this.GuardarFirmas.name);
      const firmas = [];
      if (this.signatureSavedCharged !== null) {
        firmas.push(this.signatureSavedCharged);
      }
      if (this.signatureSavedReceived !== null) {
        firmas.push(this.signatureSavedReceived);
      }
      if (firmas.length > 0) {
        this.showPreload = true;
        HiDialog.Preloader(true, this.$t('commercialization.common.savingSignatures'));
        await this.Conexion_GuardarFirmasOrdenCarga(firmas, this.documentoExpedicion.Id);
        await this.Conexion_ObtenerFirmasOrdenCarga(this.documentoExpedicion.Id);
        this.showPreload = false;
        HiDialog.Preloader(false);
      }

      this.openSignOption = false;
    },
    updateSignatureReceived(newValue) {
      this.signatureReceived = newValue;
      const base64Content = newValue.split(',')[1];
      if (this.signatureSavedReceived !== null) {
        this.signatureSavedReceived.Archivo = base64Content;
      } else {
        this.signatureSavedReceived = {
          Id: 0,
          Nombre: '#ReceptorMercancia',
          Archivo: base64Content,
        };
      }
    },
    updatesignatureCharged(newValue) {
      this.signatureCharged = newValue;
      const base64Content = newValue.split(',')[1];
      if (this.signatureSavedCharged !== null) {
        this.signatureSavedCharged.Archivo = base64Content;
      } else {
        this.signatureSavedCharged = {
          Id: 0,
          Nombre: '#CargadorMercancia',
          Archivo: base64Content,
        };
      }
    },
    async EventDeleteLine() {
      Log(this, this.EventDeleteLine.name);

      const alertText = this.$t('commercialization.deleteLoadingOrderConfirmation.text');
      const alertTitle = this.$t('commercialization.deleteLoadingOrderConfirmation.title');
      const resultConfirm = await ConfirmDialogGH(alertText, alertTitle);

      if (!resultConfirm) {
        return;
      }

      HiDialog.Preloader(true, this.$t('commercialization.deleteLoadingOrderConfirmation.preloaderText'));
      const resultSave = await this.DeleteExpedition(this.expeditionDocument);
      HiDialog.Preloader(false);

      if (resultSave == null) {
        return;
      }
      // Si es la unica linea de Expedición disponible en la orden de carga volvemos al formulario inicial de ordenes de carga.
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpedition', {
        ignoreCache: true,
        reloadPrevious: true,
        props: {
          reload: true,
        },
      });
      await sleep(500);
      f7.views.main.router.back();
    },
    async ChangeStateExpedition() {
      Log(this, this.ChangeStateExpedition.name);
      this.$refs.UCConfirmation.create(
        this.$t('commercialization.changeExpeditionStatus.title'),
        this.$t('commercialization.changeExpeditionStatus.text'),
        () => {
          this.ChangeStateToProcess();
        },
      );
      this.$refs.UCConfirmation.show();
    },

    async PrintExpedition() {
      Log(this, this.PrintExpedition.name);

      this.disablePrint = true;
      const result = await this.SENDPrintLabelExpedition(this.expeditionDocument.Id);
      if (result) {
        HiNotification.Toast(this.$t('common.successfulPrinting'));
      } else {
        HiNotification.Toast(this.$t('common.labelCannotBePrinted'));
      }
      this.disablePrint = false;
    },

    NavigateToEditExpeditionLine(objLineExpedition) {
      Log(this, this.NavigateToEditExpeditionLine.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocumentAddPale', {
        props: {
          lineExpedition: objLineExpedition,
          expedition: this.documentoExpedicion,
        },
      });
    },
    async BackToMain() {
      Log(this, this.BackToMain.name);
      if (this.reload) {
        this.Back();
      } else {
        f7.views.main.router.back();
      }
    },
    async Back() {
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpedition', {
        ignoreCache: true,
        reloadPrevious: true,
        props: {
          reload: this.reload,
        },
      });
      await sleep(500);
      f7.views.main.router.back();
    },

    async ChangeStateToProcess() {
      Log(this, this.ChangeStateToProcess.name);
      HiDialog.Preloader(true, this.$t('commercialization.changeExpeditionStatus.preloaderText'));
      const resultValidation = await this.Conexion_ValidatePaleWithoutSalesReceipt();
      if (resultValidation.length > 0) {
        HiNotification.Toast(this.$t('commercialization.changeExpeditionStatus.validationError'), 3000);
      } else {
        await APIErp.callChangeEspeditionState(this.expeditionDocument, 1, true);
        f7.views.main.router.back('', { force: true });
      }
      HiDialog.Preloader(false);
    },

    async FinalizeExpedition() {
      Log(this, this.FinalizeExpedition.name);

      if (this.complementaryData.length > 0) {
        if (this.checkRequiredComplementaryData()) {
          return;
        }

        this.filterComplementaryData();
        this.GuardarDatosComplementariosExpedicion();
      }

      const alertTitle = this.$t('commercialization.finishExpedition.title');
      const alertText = this.$t('commercialization.finishExpedition.text', { order: `${this.expeditionDocument.Serie}/${this.expeditionDocument.Numero}` });
      const resultConfirm = await ConfirmDialogGH(alertText, alertTitle);

      if (!resultConfirm) {
        return;
      }

      HiDialog.Preloader(true, this.$t('commercialization.finishExpedition.preloaderText'));
      try {
        const result = await APIErp.callChangeEspeditionState(this.expeditionDocument, 2, false);
        HiDialog.Preloader(false);
        if (result.data.valor) {
          f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionSalesReceipt', {
            props: {
              expedition: this.expeditionDocument,
            },
          });
        } else {
          HiNotification.Toast(result.data.mensaje);
        }
      } catch (error) {
        LogError(this, this.FinalizeExpedition.name, error);
        HiDialog.Preloader(false);
        HiNotification.Toast(error);
      }
    },

    GetItemAfterClassByQuantity(item) {
      if (item.CantidadTotalCargada === 0) {
        return 'pending';
      }
      if (item.CantidadTotalCargada === item.CantidadTotalPales) {
        return 'finished';
      }
      return 'in-process';
    },

    async Conexion_ValidatePaleWithoutSalesReceipt() {
      Log(this, this.Conexion_ValidatePaleWithoutSalesReceipt.name);
      const elementosNumeroSerie = [];
      this.documentoExpedicion.Lineas.forEach((i) => {
        i.Desglose.forEach((j) => {
          if (j.UnidadContenedora != null) {
            elementosNumeroSerie.push(j.UnidadContenedora.Id);
          }
        });
      });
      let cadena = elementosNumeroSerie.join(',');
      if (cadena.endsWith(',')) {
        cadena = cadena.slice(0, -1);
      }
      const result = await callExecuteSPERP(
        'APPERPAGRO_AlbaranesVentaXNumerosSerie',
        [{ NombreParametro: 'idsNumerosSerie', Valor: cadena }],
        'Compras.AlbaranVentaJSON',
      );
      if (result.status !== 200) {
        HiNotification.Toast(this.$t('commercialization.info.somePalletsCouldNotBeValidated'));
        return null;
      }
      return result.data;
    },
    async Conexion_GuardarFirmasOrdenCarga(firmas, idOrdenCarga) {
      Log(this, this.Conexion_GuardarFirmasOrdenCarga.name);
      const result = await APIErp.callGuardarFirmasOrdenCarga(firmas, idOrdenCarga);
      return result.data;
    },
    async Conexion_ObtenerFirmasOrdenCarga(idOrdenCarga) {
      Log(this, this.Conexion_ObtenerFirmasOrdenCarga.name);
      try {
        const result = await APIErp.callObtenerFirmasOrdenCarga(idOrdenCarga);
        if (result.data.valor) {
          result.data.tag.forEach((element) => {
            if (element.Nombre === '#ReceptorMercancia') {
              this.signatureSavedReceived = element;
              this.signatureReceived = element.Archivo;
              [, this.signatureSavedReceived.Archivo] = this.signatureSavedReceived.Archivo.split(',');
            }
            if (element.Nombre === '#CargadorMercancia') {
              this.signatureSavedCharged = element;
              this.signatureCharged = element.Archivo;
              [, this.signatureSavedCharged.Archivo] = this.signatureSavedCharged.Archivo.split(',');
            }
          });
        }
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error, this.$t('common.warning'));
      }
    },
    async Conexion_GetExpedition(expeditionDocument) {
      Log(this, this.Conexion_GetExpedition.name);
      this.showPreload = true;
      if (!this.lecturaContinuaCargasExpediciones) {
        HiDialog.Preloader(true, this.$t('common.loadingData'));
      }
      const result = await APIErp.callGetExpedition(expeditionDocument, [0, 1, 2], this.userEnviroment.EntornoDeTrabajo.Centro);
      [this.documentoExpedicion] = result.data;
      this.GetAccordeonList(this.documentoExpedicion);
      this.Conexion_ObtenerFirmasOrdenCarga(this.documentoExpedicion.Id);
      this.showPreload = false;
      if (!this.lecturaContinuaCargasExpediciones) {
        HiDialog.Preloader(false);
      }
    },
    async Conexion_CargaRelacionadaEnOtroCentro(idOrdenCarga) {
      Log(this, this.Conexion_CargaRelacionadaEnOtroCentro.name);
      const result = await callExecuteSPERP(
        'APPERPAGRO_OrdenCargaPendienteEnOtroCentro',
        [{ NombreParametro: 'idOrden', Valor: idOrdenCarga }],
        'Almacen.ExpedicionJSON',
      );
      if (result.status !== 200) {
        HiNotification.Toast(this.$t('commercialization.info.notPossibleToCheckCargoAnotherCenter'));
        return;
      }
      if (result.data.length > 0) {
        this.pendienteEnOtroCentro = true;
      }
    },
    async GetPaleReservado(numeroSerie) {
      Log(this, this.GetPaleReservado.name);
      HiDialog.Preloader(true, this.$t('commercialization.info.searchingSalesOrderLineReservations'));
      const result = await callExecuteSPERP(
        'APPERPAGRO_ReservaArticulosXNumerosSerie',
        [{ NombreParametro: 'numeroSerie', Valor: numeroSerie }],
        'Almacen.UnidadContenedoraJSON',
      );
      HiDialog.Preloader(false);
      if (result.status !== 200) {
        HiNotification.Toast(this.$t('commercialization.info.cannotGetPalletData'));
        return null;
      }
      return result.data;
    },

    async DeleteExpedition(objExpedition) {
      HiDialog.Preloader(true, this.$t('commercialization.info.deletingExpedition'), false);
      try {
        const result = await APIErp.callDeleteExpedition(objExpedition);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error, this.$t('common.warning'));
        return null;
      }
    },
    async SENDPrintLabelExpedition(idOrdenCarga) {
      Log(this, this.SENDPrintLabelExpedition.name);
      const result = await APIErp.callImprimirOrdenCarga(idOrdenCarga);
      if (result.Valor) {
        return true;
      }
      return false;
    },

  },
};
</script>

<style lang="scss">
.main-status-summary {
  --available-viewport-height: calc(100vh - var(--information-bar-height));

  .disabled-component {
    opacity: 0.6;
    pointer-events: none;
  }

  .editar {
    font-size: 15px;
    color: var(--f7-color-white);
  }

  .custom-accordion {
    >ul {
      >li {
        >.item-link {
          .item-title {
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
        }
      }

      &::before,
      &::after {
        height: 0;
      }
    }

    .storybook-action-sorted-accordion {
      .accordion-list {
        --f7-badge-bg-color: var(--his-soft-blue);
        --f7-badge-size: 24px;
        --f7-badge-font-weight: 400;
        --f7-badge-font-size: 13px;
        --f7-badge-text-color: var(--his-dark-blue);

        ul {
          .accordion-item-opened {
            .item-link {
              &::after {
                border-top: 0;
              }

              .item-content {
                background-color: #fff;
                padding-right: 5px;
              }
            }
          }

          .accordion-item {
            .item-inner {
              .item-content {
                .item-title {
                  -webkit-box-orient: vertical;
                  display: -webkit-box;
                  -webkit-line-clamp: 4;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: normal;
                  padding-right: 40px;
                }
              }
            }
          }
        }
      }

      .list:not(.media-list) > ul > .accordion-item:not(.media-item) > .item-inner > .item-link::before {
        color: var(--his-slate-blue) !important;
      }
    }

    .accordion-item > .item-link {
      background-color: var(--his-slate-blue);
      --f7-list-item-title-text-color: #fff;
      --f7-list-chevron-icon-color: #fff;
    }
  }

  .accordion {
    height: calc(var(--available-viewport-height) - 200px);
    overflow-y: scroll;
    background-color: #fff;

    .accordion-item-content {
      .list {
        --f7-list-item-title-text-color: var(--his-slate-blue);
        --f7-list-item-title-font-size: 16px;
        --f7-list-media-item-title-font-weight: 400;
        --f7-list-item-subtitle-font-size: 12px;
        --f7-list-item-subtitle-text-color: var(--his-ash-gray);
        --f7-list-item-subtitle-font-weight: 400;
        --f7-list-item-subtitle-line-height: 1.4;
        --f7-list-item-text-font-size: 12px;
        --f7-list-item-text-text-color: var(--his-oliva);
        --f7-list-item-text-font-weight: 400;
        --f7-list-item-text-line-height: 1.6;
        --f7-list-chevron-icon-color: var(--his-blueberry-frost);
      }

      .item-info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &__start {
          width: 100%;
          text-transform: uppercase;
          padding: 4px 8px;
        }

        &__end {
          min-width: 70px;
          margin-left: 5px;
          margin-right: 4px;
          padding: 4px;
          text-align: center;
        }

        &__start,
        &__end {
          font-weight: 400;
          font-size: 12px;
          border-radius: 3px;
          margin-bottom: 8px;

          &.in-process {
            background-color: var(--his-mandarina-tint);
            color: #ba5333;
          }

          &.pending {
            background-color: var(--his-disabled);
            color: var(--his-oliva);
          }

          &.finished {
            background-color: #e5f6d3;
            color: #66ba33;
          }
        }
      }

      .item-title-row,
      .item-subtitle,
      .item-text,
      .item-footer {
        padding-left: 8px;
      }
    }
  }

  .content-header {
    color: #fff;

    .list {
      background-color: var(--his-slate-blue);
      --f7-list-item-min-height: 30px;
      --f7-list-item-title-text-color: var(--his-disabled);
      --f7-list-item-title-font-size: 14px;
      --f7-list-item-title-font-weight: 400;
      --f7-list-item-after-text-color: #fff;
      --f7-list-item-after-font-size: 16px;
      --f7-list-item-after-padding: 0;
      --f7-list-bg-color: var(--his-slate-blue);

      ul {
        &::before,
        &::after {
          height: 0;
        }
      }

      .item-content {
        .item-inner {
          display: grid;
          grid-template-columns: 1.2fr 2fr;

          &::after {
            height: 0;
          }

          .item-after {
            margin: 0;
          }
        }
      }
    }
  }

  .content-button {
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid var(--his-silver);
    background-color: #fff;

    .button {
      --f7-button-pressed-bg-color: var(--his-slate-blue);
      --f7-button-bg-color: var(--his-oliva);
    }
  }

  .menu-label {
    width: 100%;
    text-align: left;
    font-weight: bold;
  }

  .actions-content {
    width: 99%;

    // height: 290px;
    background: #fff;
    border: 0.2px solid #d8d8d8;

    .action-label {
      font-size: var(--f7-actions-label-font-size);
      display: contents;
      color: var(--f7-actions-label-text-color);

      // padding: 0px;
      text-align: left;
    }

    /* .item-title{
          height: 54px;
          font-weight: 500;
          margin-top: 5px;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: -0.07px;
          color: var(--his-tierra);
          align-content: center !important;
        } */
    .actions-btn {
      border-radius: 5px;
      font-weight: 500;
      font-size: 15px;
      letter-spacing: -0.15px;
    }

    .actions-btn1 {
      background: #fff;
      color: var(--his-metal);
      border: 2px solid var(--his-metal);
    }

    .actions-btn2 {
      background: var(--his-tierra);
      color: #fff;
      border: 2px solid var(--his-metal);
    }

    .actions-btn3 {
      background: #fff;
      color: var(--his-tomate);
    }
  }
}

.actions-label {
  // justify-content: left;
  // padding: 0px;
  text-align: left;
  color: var(--his-dark-blue);
}

.actions-label-back {
  color: #b70000;
}

.actions-grid .actions-button-text {
  // text-align: left !important;
  font-size: 15px;

  // padding-left: 10px;
  .text-left {
    width: 100%;
    display: flex;
    margin-left: 10px;
  }
}

.content-action .actions-button {
  color: var(--his-slate-blue) !important;
  text-transform: none !important;
  width: 100% !important;
}

.content-action .actions-button-back {
  color: #b70000 !important;
  text-transform: none !important;
}

.acceptCancelBox {
  justify-items: space-between;
}

.content-action-sheet {
  &--items {
    display: flex;
    flex-direction: column;
    padding-bottom: 60px;

    &__title {
      font-size: 14px;
      font-weight: 400;
      padding-bottom: 24px;
      color: var(--his-steel-blue);
      justify-items: space-between;
    }

    &__buttons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      width: 100%;

      a {
        font-size: 14px;
        font-weight: 400;
      }

      .aceptar-button {
        font-size: 18px;
        font-weight: 500;
        align-content: right;
      }
    }

    &__stepper {
      --f7-stepper-fill-button-text-color: #fff;
      --f7-stepper-height: 36px;
      --f7-stepper-border-radius: 0px;

      .stepper-input-wrap {
        input {
          width: 100px;
          border: none;
        }
      }

      .actions-label::after {
        height: 0 !important;
      }
    }
  }
}

.signOption {
  justify-content: center;
}

.content-main-status-summary-popup {
  &__complementary-data {
    height: calc(100% - var(--f7-navbar-height) - 40px);
    --f7-list-bg-color: var(--his-tierra-white);
    --f7-list-border-color: none;

    .item-input-wrap {
      border: var(--search-input-border);
      --f7-input-padding-left: 5px;
      --f7-input-padding-right: 5px;
    }
  }
}
</style>
